/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';

import template from './release-notes-modal.component.html';

@Component({
  standalone: false,
  selector: 'adn-release-notes-modal',
  template
})
export class ReleaseNotesModalComponent {
  /** Set via BsModalService initialState */
  apps: string[];

  constructor(public bsModalRef: BsModalRef) {
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
